import jQuery from 'jquery';
import { PopOver, BestOdds, BetHandler, pricesProvider } from 'rp-prices-component';
import rpPopup, { backLink } from 'rp-popup';
import rpUrlNavigationPrefs from 'rp-url-navigation-prefs';
import rpGuiGuide, { accordions } from 'rp-gui-guide';
import rpAdvertising from 'rp-advertising';
import { cleanLegacy } from 'rp-cookie';
import initBookmakerRegPanel from 'rp-betting-special-offer';
import { appPromo } from 'rp-navigation';

import { bootstrap } from './bootstrap';
import analyticsPage from './analyticsPage';
import MandatoryLogin, { config as MandatoryLoginConfig } from './modules/mandatoryLogin';
import RedirectHandler from './modules/redirectHandler';
import Bindings from './modules/bindings';
import BookieSelection from './modules/bookieSelection/bookieSelection';
import { bookieSelectionConfig } from './modules/bookieSelection/bookieSelection.config';
import cardSort from './modules/cardSorting';
import { cardSortConfig } from './modules/cardSorting/cardSort.config';
import CardHeader from './modules/cardHeader';
import CardTabs from './modules/cardTabs';
import ChooseBookie from './modules/chooseBookie';
import ChooseBookieExperiment from './modules/chooseBookieExperiment';
import CustomizeSettings from './modules/customizeSettings/customizeSettings';
import { customizeSettingsConfig } from './modules/customizeSettings/customizeSettings.config';
import { settingsPopOverConfig } from './modules/customizeSettings/settingsPopOver.config';
import SecondaryNavigation from './modules/secondaryNavigation';
import Lightbox from './modules/lightbox/lightbox';
import { lightboxConfig } from './modules/lightbox/lightbox.config';
import { PriceHandlers } from './modules/priceHandlers';
import PredictorHandler from './modules/predictorHandler';
import TextCommentaries from './modules/textCommentaries/textCommentaries';
import { textCommentariesConfig } from './modules/textCommentaries/textCommentaries.config';
import IOSRotationHandler from './modules/iosRotationHandler';
import MatrixPopover from './modules/matrixPopOver/matrixPopover';
import { matrixPopOverConfig } from './modules/matrixPopOver/matrixPopOver.config';
import MobileHandler from './modules/mobileHandler';
import Notes from './modules/notes';
import DynamicAccordions from './modules/dynamicAccordions';
import DynamicRunners from './modules/dynamicRunners';
import RaceDayLive from './modules/raceDayLive';
import preopenAccordions from './modules/preopenAccordions';
import eachWay from './modules/eachWay';
import WatchLive from './modules/watchLive';
import BetAndLoginToWatchCourseList from './modules/betAndLoginToWatchCourseList';
import BetslipInteracter from './modules/betslipInteracter';
import myRating from './modules/myRating';
import odds from './modules/odds';
import oddsPopup from './modules/odds/variant4popup';
import form from './modules/form/form';
import deviceDetect from './modules/deviceDetect';
import addExperimentStyles from './modules/bookieSelection/experimentStyles';
import RaceOffers from './modules/raceOffers';

import '../css/main.scss';

analyticsPage();
cleanLegacy();

let app = {};

const configs = {
    mandatoryLogin: MandatoryLoginConfig,
    lightbox: lightboxConfig,
    bookieSelection: bookieSelectionConfig,
    matrixPopOver: matrixPopOverConfig,
    settingsPopOver: settingsPopOverConfig,
    customizeSettings: customizeSettingsConfig,
    cardSort: cardSortConfig,
    textCommentaries: textCommentariesConfig,
    dynamicAccordions: {
        handleSuccess(scope) {
            if (app.modules.hashOfAccordions) {
                jQuery.extend(app.modules.hashOfAccordions, accordions());
            } else {
                app.modules.hashOfAccordions = accordions();
            }
            scope.config.rows.forEach(type =>
                preopenAccordions(app.modules.hashOfAccordions, type));
        }
    },
    bestOdds: {
        activeBestOddsSelector: {
            horseList: '.js-diffusionBestOddsMain',
        },
    },
};

app = bootstrap(app, {
    mandatoryLogin: MandatoryLogin,
    redirectHandler: RedirectHandler,
    priceHandlers: PriceHandlers,
    secondaryNavigation: SecondaryNavigation,
    lightbox: Lightbox,
    bindings: Bindings,
    bookieSelection: BookieSelection,
    bestOdds: BestOdds,
    matrixPopOver: PopOver,
    settingsPopOver: PopOver,
    predictorHandler: PredictorHandler,
    customizeSettings: CustomizeSettings,
    cardSort,
    betHandler: BetHandler,
    textCommentaries: TextCommentaries,
    iOSRotationHandler: IOSRotationHandler,
    matrixPopover: MatrixPopover,
    notes: Notes,
    dynamicAccordions: DynamicAccordions,
    dynamicRunners: DynamicRunners,
    cardHeader: CardHeader,
    cardTabs: CardTabs,
    raceDayLive: RaceDayLive,
    eachWay,
    watchLive: WatchLive,
    betAndLoginToWatchCourseList: BetAndLoginToWatchCourseList,
    betslipInteracter: BetslipInteracter,
    myRating,
    odds,
    oddsPopup,
    form,
}, configs);

rpPopup();
backLink();
rpAdvertising();
appPromo.init();
initBookmakerRegPanel();

if (jQuery('.RC-raceOffersPanel')[0]) {
    const raceOffers = new RaceOffers();
    raceOffers.init(jQuery('.RC-raceOffersPanel'));
}

const hashOfAccordions = accordions();
app.modules.hashOfAccordions = hashOfAccordions;
const accordionName = location.hash.substr(1);
preopenAccordions(
    hashOfAccordions,
    accordionName
);

rpUrlNavigationPrefs();
rpGuiGuide({
    svg: { polyfill: true }
});

function initChooseBookie(bindExperimentClickEvent) {
    app.modules.chooseBookie.init()
        .then((feedName) => {
            MobileHandler();
            app.initModules();
            if (bindExperimentClickEvent && deviceDetect.phone()) {
                app.modules.bookieSelection.bookieSelectionContainer
                    .on('click', () => { app.modules.chooseBookie.bindEvents(true); });
            }
            return feedName;
        })
        .then(feedName =>
            app.modules.betslipInteracter
                .init(feedName)
                .then(betslipFeedName => feedName || betslipFeedName)
        )
        .then((feedName) => {
            pricesProvider.init(feedName);
            app.modules.customizeSettings.publishSettingsData();
            jQuery.cookie('chooseBookie', feedName, {
                domain: `.${location.host.split('.').slice(1).join('.')}`,
                path: '/',
                expires: 365
            });
        });
}

// onboarding journey: old design, no bookieSelection button
function createVariant0() {
    const chooseBookieInstance = new ChooseBookie(true);
    app.modules.chooseBookie = chooseBookieInstance;
    initChooseBookie(false);
}

// onboarding journey: new design, no bookieSelection button
function createVariant1() {
    const chooseBookieInstance = new ChooseBookieExperiment(true);
    app.modules.chooseBookie = chooseBookieInstance;
    initChooseBookie(false);
}

// onboarding journey: old design, with bookieSelection button
function createVariant2() {
    const chooseBookieInstance = new ChooseBookie(false);
    app.modules.chooseBookie = chooseBookieInstance;
    initChooseBookie(true);
    addExperimentStyles();
}

// onboarding journey: new design, with bookieSelection button
function createVariant3() {
    const chooseBookieInstance = new ChooseBookieExperiment(false);
    app.modules.chooseBookie = chooseBookieInstance;
    initChooseBookie(true);
    addExperimentStyles();
}

function initializeChooseBookie() {
    const variant = window.onboardingJourney ? window.onboardingJourney.variant : 0;

    if (!app.modules.chooseBookie) {
        switch (variant) {
            case 0:
                createVariant0();
                break;
            case 1:
                createVariant1();
                break;
            case 2:
                createVariant2();
                break;
            case 3:
                createVariant3();
                break;
            default:
                createVariant0();
        }
    }
}

jQuery(window).on('load', initializeChooseBookie);




// WEBPACK FOOTER //
// ./lib/js/app.js